import React, { useState } from 'react'
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap'
import UsersModal from '../AccessibilityModal/UsersModal'
import LocationGroupsModal from '../AccessibilityModal/LocationGroupsModal'
import LocationsModal from '../AccessibilityModal/LocationsModal'
import JobTitleModal from '../AccessibilityModal/JobTitleModal'
import RoleGroupsModal from '../AccessibilityModal/RoleGroupsModal'

const AccessibilitySelect = (props) => {
  const { nameHolder, groups, stores, users, roles, roleGroups } = props
  const [items, setItems] = useState([])
  const [jobTitleModal, setJobTitleModal] = useState(false)
  const [locationsModal, setLocationsModal] = useState(false)
  const [usersModal, setUsersModal] = useState(false)
  const [locationGroupModal, setLocationGroupModal] = useState(false)
  const [roleGroupsModal, setRoleGroupsModal] = useState(false)

  return (
    <>
      {usersModal && (
        <UsersModal
          isOpen={usersModal}
          setUsersModal={setUsersModal}
          items={items}
          groups={groups}
          users={users}
        />
      )}

      {locationGroupModal && (
        <LocationGroupsModal
          isOpen={locationGroupModal}
          setLocationGroupModal={setLocationGroupModal}
          items={items}
          groups={groups}
          associateType='location'
        />
      )}

      {locationsModal && (
        <LocationsModal
          isOpen={locationsModal}
          setLocationsModal={setLocationsModal}
          items={items}
          groups={groups}
          assignableTrainingStores={props.assignableTrainingStores}
        />
      )}

      {jobTitleModal && (
        <JobTitleModal
          isOpen={jobTitleModal}
          setJobTitleModal={setJobTitleModal}
          items={items}
          groups={groups}
          assignableTrainingRoles={props.assignableTrainingRoles}
        />
      )}

      {roleGroupsModal && (
        <RoleGroupsModal
          isOpen={roleGroupsModal}
          setRoleGroupsModal={setRoleGroupsModal}
          items={items}
          groups={groups}
        />
      )}

      <UncontrolledDropdown>
        <DropdownToggle
          caret
          color='secondary'
          className='px-5'
          style={{ padding: '6px 12px' }}
        >
          {nameHolder}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            className='text-dark'
            onClick={() => {
              setItems(users.assignableUsers)
              setUsersModal(true)
            }}
          >
            <span>Users</span>
          </DropdownItem>
          {!props.doNotAssign ? (
            <DropdownItem
              onClick={() => {
                setItems(groups)
                setLocationGroupModal(true)
              }}
            >
              <span>Location group</span>
            </DropdownItem>
          ) : null}
          {!props.doNotAssign ? (
            <DropdownItem
              onClick={() => {
                setItems(stores)
                setLocationsModal(true)
              }}
            >
              Location
            </DropdownItem>
          ) : null}
          {!props.doNotAssign ? (
            <DropdownItem
              onClick={() => {
                setItems(roles)
                setJobTitleModal(true)
              }}
            >
              Job title
            </DropdownItem>
          ) : null}
          {!props.doNotAssign ? (
            <DropdownItem
              onClick={() => {
                setItems(roleGroups)
                setRoleGroupsModal(true)
              }}
            >
              Role groups
            </DropdownItem>
          ) : null}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  )
}

export default AccessibilitySelect
